import { Injectable } from '@angular/core';

@Injectable()
export class FlashService {

  constructor() { }

  show(text,className) {

  }
  
  hide() {

  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/flash/flash.service.ts